module.exports = __webpack_public_path__ + "static/media/github (1).b6ec19ce.png";